import * as React from 'react';

const RENDER_TIMEOUT = 10000; // 10s
const IDLE_TIMEOUT = 1000;

type DeferredInitializationProps = {
  setReady: () => void;
  isTimeout: boolean;
};

export default function useDeferredInitialization(
  callback: () => void
): DeferredInitializationProps {
  const [initialized, setInitialized] = React.useState(false);
  const [timeoutId, setTimeoutId] = React.useState<number | null>(null);

  // To detect if the defer is timeout
  const [isTimeout, setIsTimeout] = React.useState<boolean>(false);

  // To detect if the page has completed the critical rendering
  const [
    hasCompletedCriticalRender,
    setHasCompletedCriticalRender,
  ] = React.useState(false);

  const setReady = React.useCallback(() => {
    window.requestIdleCallback(() => setHasCompletedCriticalRender(true), {
      timeout: IDLE_TIMEOUT,
    });

    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  }, [timeoutId]);

  React.useEffect(() => {
    const id: number = window.setTimeout(() => {
      setIsTimeout(true);
    }, RENDER_TIMEOUT);

    setTimeoutId(id);

    return () => window.clearTimeout(id);
  }, []);

  React.useEffect(() => {
    if (!initialized && (hasCompletedCriticalRender || isTimeout)) {
      callback();
      setInitialized(true);
    }
  }, [hasCompletedCriticalRender, isTimeout, initialized, callback]);

  return { setReady, isTimeout };
}
